<template>
  <div :class="[classDiv,'placeholder-glow']">
    <div class="form-floating mb-3">
      <input :type="tipo" :class="['form-control', tam_input, class_placeholder]" :name="nome" :id="nome" :aria-describedby="id_descr"
        :placeholder="placeholder" v-mask="mascara" :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)" />
      <label :for="nome ? nome : ''" v-if="label" class="form-label">
        {{ label }}
      </label>
      <div :id="id_descr" v-if="descricao" class="form-text">
        {{ descricao }}
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  name: "InputTextMask",
  props: {
    tipo: {
      default: "tel",
    },
    tamanho: {
      default: "",
    },
    nome: {
      default: "nome",
    },
    mask: {
      default: "cel",
    },
    ativa_placeholder: {
      default: false,
    },
    modelValue: '',
    classDiv: String,
    valor: String,
    label: String,
    id: String,
    placeholder: String,
    id_descr: String,
    descricao: String,
  },
  emits: ["update:modelValue"],
  components: {},
  directives: { mask },
  data() {
    return {
      model_input: "",
    };
  },
  computed: {
    tam_input: function () {
      if (this.tamanho == "") {
        return "";
      } else {
        return "form-control-" + this.tamanho;
      }
    },
    mascara: function () {
      switch (this.mask) {
        case "tel":
          return "(##) ####-####";
          break;
        case "cel":
          return ["(##) ####-####", "(##) #####-####"];
          break;
        case "rg":
          return "##.###.###-#";
          break;
        case "cpf":
          return "###.###.###-##";
          break;
        case "cnpj":
          return "##.###.###/####-##";
          break;
        case "cep":
          return "#####-###";
          break;
        case "databr":
          return "##/##/####";
          break;
        case "money":
          return ["#,##","##,##","###,##","#.###,##","##.###,##","###.###,##","#.###.###,##"];
          break;

        default:
          return "(##) # ####-####";
          break;
      }
    },
    class_placeholder: function(){
      return (this.ativa_placeholder ? 'placeholder' : '')
    }
  },
};
</script>

<style scoped>
label {
  font-size: 1rem !important;
  color: #999;
}
</style>